import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

import { theme } from './theme';

export const AppBadges: FunctionComponent = (props) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
    >
      <a href="https://apps.apple.com/sa/app/matematyka-gryzie/id1560733130">
        <img
          className="lazyload"
          data-src="assets/badges/app-store.svg"
          alt="Pobierz aplikację matematyka gryzie z App Store"
          width={145}
          height={48}
          style={{ margin: theme.spacing(1) }}
        />
      </a>
      <a href="https://play.google.com/store/apps/details?id=pl.matematykagryzie.app&gl=PL">
        <img
          className="lazyload"
          data-src="assets/badges/google-play.svg"
          alt="Pobierz aplikację matematyka gryzie z Google Play"
          style={{ margin: theme.spacing(1) }}
          width={163}
          height={48}
        />
      </a>
      <a href="https://appgallery.huawei.com/#/app/C104275079">
        <img
          className="lazyload"
          data-src="assets/badges/app-gallery.svg"
          alt="Pobierz aplikację matematyka gryzie z App Gallery"
          style={{ margin: theme.spacing(1) }}
          width={161}
          height={48}
        />
      </a>
      <a href="https://app.matematykagryzie.pl">
        <img
          className="lazyload"
          data-src="assets/badges/web.svg"
          alt="Aplikacja matematyczna dostępna w przeglądarce"
          style={{ margin: theme.spacing(1) }}
          width={168}
          height={48}
        />
      </a>
    </Box>
  );
};

export default AppBadges;
